<label class="container">
  {{ label }}
  <input
    [disabled]="disabled === true"
    name="{{ name }}"
    type="checkbox"
    [checked]="checked"
    (change)="onChange($event)" />
  <span class="checkmark"></span>
</label>
